<template>
  <div>
    <b-row class="float-right mb-3">
      <span>Exibir</span>
      <select class="ml-2" v-model="rowsPerPage">
        <option v-for="pageSize in pageSizeMenu" :value="pageSize" v-bind:key="pageSize">
          {{ pageSize }}
        </option>
      </select>
      <span class="ml-2 mr-3">Linhas</span>
    </b-row>

    <b-row>
      <p class="mr-3">Emissão de DRAM(s)</p>
    </b-row>

    <b-table responsive stacked="md" :bordered="true" striped hover selectable :small="true" :items="items"
      :fields="fields" :per-page="rowsPerPage" :current-page="currentPage" show-empty
      empty-text="Tente novamente. Erro inesperado na rotina retorna_guia_avista." primary-key="id" summary="Tabela Guias Vista">
      <template #head(DESCRICAO)>
        <span v-b-tooltip.hover.html="{ variant: 'primary' }"
          title="agrupamento de lançamentos conforme características da seleção feita.">
          Descrição
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(NUMEROGUIA)>
        <span v-b-tooltip.hover.html="{ variant: 'primary' }" title="número do DRAM (Documento de Recolhimento e Arrecadação
                 Municipal) para acompanhamento e emissão de relatórios.">
          Número da DRAM
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #cell(DATAVENCIMENTO)="{ item }">
        {{ formatDateTime(item.DATAVENCIMENTO) }}
      </template>

      <template #cell(VALORTOTAL)="{ item }">
        {{ formatCurrency(item.VALORTOTAL) }}
      </template>

      <template #cell(VALORDESCONTO)="{ item }">
        {{ formatCurrency(item.VALORDESCONTO) }}
      </template>

      <template #cell(URLEMISSAO)="{ item, index }">
        <div class="text-center">
          <b-button size="sm" :variant="btnSelecionados.findIndex((e) => e.id === `${currentPage}${index}`) !== -1
            ? 'danger'
            : 'primary'
            " @click="guiaPagamentoAVista(item.URLEMISSAO, currentPage, index)" class="mr-1">
            {{
              btnSelecionados.findIndex((e) => e.id === `${currentPage}${index}`) !== -1
              ? "DRAM emitida"
              : "Emitir DRAM"
            }}
          </b-button>
        </div>
      </template>

      <template #cell(URLRELACAO)="{ item }">
        <div class="text-center" v-if="item.URLRELACAO != null">
          <div v-if="item.IDGRUPO == 5">
            <b-button size="sm" variant="success" @click="verLancamentosAVista(item.URLRELACAO)" class="mr-1">
              Ver demonstrativo ITBI
            </b-button>
          </div>
          <div v-else>
            <b-button size="sm" variant="success" @click="verLancamentosAVista(item.URLRELACAO)" class="mr-1">
              Ver lançamentos
            </b-button>            
          </div>
        </div>
      </template>
    </b-table>
    <b-row class="d-flex justify-content-between mx-3">
      <b-col>
        <strong>Total de registros: {{ items.length }}</strong>
        <br />
        Página {{ currentPage }} de
        {{ Math.ceil(items.length / rowsPerPage) }}
      </b-col>
      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="rowsPerPage" aria-controls="my-table"
        align="right">
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    items: Array,
    fields: Array,
    title: String,
  },
  data() {
    return {
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,
      ordenarPor: "",
      ordenacaoDecrescente: false,
      ordenacaoDirecao: "asc",
      btnSelecionados: [],
      chaveID: "",
      textoButton: "",
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },

  methods: {
    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    formatDateTime: function (value) {
      if (!value) return "";
      else return moment.utc(value).format('DD/MM/YYYY')
    },

    verLancamentosAVista(url) {
      const link = url;
      this.downloadArquivo(link, "lancamentos");
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl)
    },

    guiaPagamentoAVista(url, ind1, ind2) {
      const str1 = ind1;
      const str2 = ind2;
      this.chaveID = `${str1}${str2}`;

      const ind = this.btnSelecionados.findIndex((e) => e.id === this.chaveID);

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionados = this.btnSelecionados.filter(
          (item) => item.id != this.chaveID
        );
      } // inclui ( clicado )
      else {
        this.btnSelecionados.push({ id: this.chaveID });
        const link = url;
        this.downloadArquivo(link, "emissaoDRAM");
      }
    },
  },
};
</script>
